import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_434zfwvrgm: FaireBrandEntity = {
  token: "b_434zfwvrgm",
  type: "brand",
  name: "Ekartini",
  avatarUrl:
    "https://cdn.faire.com/fastly/4b14724848ecf486cad90af69f76cb4a93b0eebef626867a4593751a20cb9683.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/22228e8b6b81ba3e4f195bb78301bf36b94071997ff3f51809470097e39e4420.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4b14724848ecf486cad90af69f76cb4a93b0eebef626867a4593751a20cb9683.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/22228e8b6b81ba3e4f195bb78301bf36b94071997ff3f51809470097e39e4420.jpeg",
  location: "JACKSONVILLE, FL, USA",
  minimumOrderDollars: 130,
  rating: 3.8,
  reviewCount: 9,
  isInsider: false,
  description:
    "Ekartini Swimwear is a completely female-led global online destination for luxury, fashion-forward swimwear. Each Crush bikini is a one-of-a-kind creation, meticulously designed and handcrafted. Our brand is renowned for its immaculate feminine designs, quality, and glamorous embellishments. Most of our swimwear is ethically produced in the United States, distinguishing us as part of the 3% of businesses that continue to manufacture in the USA. Our approach avoids mass production, ensuring that each piece is crafted to meet our standards.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:22.366Z",
    importedBy: "entity-db-cli",
  },
};
